import store from '@/store'
import axios from '@axios'
import { $odb } from '@axios'
import { transformRequestOptions } from '@core/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchProjects(ctx, queryParams) {
      store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/projects/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params) 
        })
          .then(response => {
            store.commit('app/LOADING', false)
            resolve(response)
          })
          .catch(error => { 
            store.commit('app/LOADING', false)
            reject(error) 
          })
      })
    },
    fetchProject(ctx, queryParams ) {
      store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
        axios
          .get(`/jobs/projects/${queryParams.id}/`)
          .then(response => {
            store.commit('app/LOADING', false)
            resolve(response)
          })
          .catch(error => { 
            store.commit('app/LOADING', false)
            reject(error) 
          })
      })
    },
    addProject(ctx, data) {
      store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
        axios
          .post('/jobs/projects/', { 
            ...data 
          })
          .then(response => {
            store.commit('app/LOADING', false)
            resolve(response)
          })
          .catch(error => { 
            store.commit('app/LOADING', false)
            reject(error) 
          })
      })
    },
    updateProject(ctx, queryParams) {
      store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
        axios
          .patch(`/jobs/projects/${queryParams.id}/`, { 
            ...queryParams.data 
          })
          .then(response => {
            store.commit('app/LOADING', false)
            resolve(response)
          })
          .catch(error => { 
            store.commit('app/LOADING', false)
            reject(error) 
          })
      })
    },

    addMarket(ctx, {id, data}) {
      store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
        axios
          .post(`/jobs/projects/${id}/field_countries/`, { 
            ...data 
          })
          .then(response => {
            store.commit('app/LOADING', false)
            resolve(response)
          })
          .catch(error => { 
            store.commit('app/LOADING', false)
            reject(error) 
          })
      })
    },
    fetchProjectsStatus(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/project_status_summary/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params) 
        })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/users/min/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params)
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDepartments(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axios
            .get('/users/departments/', {
                params: queryParams,
                paramsSerializer: params => transformRequestOptions(params),
                
              })
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    fetchGroups(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axios
            .get('/users/teamsgroups/', {
                params: queryParams,
                paramsSerializer: params => transformRequestOptions(params),
                
              })
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    fetchOffices(ctx, queryParams) {
        return new Promise((resolve, reject) => {
          axios
            .get('/jobs/offices/', {
                params: queryParams,
                paramsSerializer: params => transformRequestOptions(params),
                
              })
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },
    fetchClients(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/clients/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
  },
    fetchCategories(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/categories/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchBusinessInit(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/business_initiatives/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCountries(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/countries/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchModules(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/modules/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProjectTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/project_types/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchResearchLocations(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/research_locations/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchResearchMethods(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/research_methods/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchServiceTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/service_types/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchBillingRules(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/billing_rules/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCurrencies(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/currencies/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchShelfTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/shelf_types/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchStudioRateCards(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/studio_rate_cards/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchQualSampleType(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/qual_sample_types/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchStatuses(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/statuses/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchFieldLocations(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/field_locations/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProjectTasks(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/tasks/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addProjectTask(ctx,  { task }  ) {
      store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
        axios
          .post('/planners/projects_tasks/', task )
          .then(response => {
            store.commit('app/LOADING', false)
            resolve(response)
          })
          .catch(error => {
            store.commit('app/LOADING', false)
            reject(error)
          })
      })
    },
    updateProjectTask(ctx, { task } ) {
      store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
        axios
          .patch(`/planners/projects_tasks/${task.id}/`, task )
          .then(response => {
            store.commit('app/LOADING', false)
            resolve(response)
          })
          .catch(error => {
            store.commit('app/LOADING', false)
            reject(error)
          })
      })
    },
    removeProjectTask(ctx, { id }) {
      store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
        axios
          .delete(`/planners/projects_tasks/${id}/`)
          .then(response => {
            store.commit('app/LOADING', false)
            resolve(response)
          })
          .catch(error => {
            store.commit('app/LOADING', false)
            reject(error)
          })
      })
    },
    fetchCSATSurvey(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/surveys/csat/${queryParams.id}/`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCSATResult(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/surveys/csat/${queryParams.id}/results/`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addCSATResult(ctx, data) {
      store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
        axios
          .post(`/surveys/csat_results/`, {
            ...data
          })
          .then(response => {
            store.commit('app/LOADING', false)
            resolve(response)
          })
          .catch(error =>  {
            store.commit('app/LOADING', false)
            reject(error)}
            )
      })
    },

    // Norms
    fetchRetailChannels(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/retail_channels/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSampleTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/sample_types/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchBrandTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/brand_types/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchClientObjs(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/client_objs/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPackChange(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/jobs/pack_changes/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              
            })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadProjects(ctx, queryParams){
      store.commit('app/LOADING', true)

      return new Promise((resolve, reject) => {
          axios
          .get(`/jobs/report/xlsx`,{
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params),
              responseType: 'blob',
              headers: {
                  'Authorization': localStorage.getItem('accessToken'),
                  'Content-Type': 'application/vnd.ms-excel;charset=UTF-8'
                  
              }
            })
          .then(response => {
              store.commit('app/LOADING', false)
              resolve(response)
          })
          .catch(error => {
              reject(error)
          })
      
      })
  },
  downloadTimeline(ctx, data ) {
    
    return new Promise((resolve, reject) => {
        axios
        .patch(`/planners/projects/${data.job_number}/xlsx/`, data, { responseType:'blob'})
        .then(response => {
            resolve(response)
        })
        .catch(error => reject(error))
    })
},


  fetchQuestionnaire(ctx, id, queryParams) {
    store.commit('app/LOADING', true)
    return new Promise((resolve, reject) => {
      axios
        .get(`/surveys/questionnaire/${id}`, {
            params: queryParams,
            paramsSerializer: params => transformRequestOptions(params)
          }
        )
        .then(response => {
          store.commit('app/LOADING', false)
          resolve(response)
        })
        .catch(error => {
          store.commit('app/LOADING', false)
          reject(error)
        })
    })
  },

  

  fetchSWOF(ctx, queryParams) {
    store.commit('app/LOADING', true)
    return new Promise((resolve, reject) => {
      axios
        .get(`/studios/swofs/`, {
            params: queryParams,
            paramsSerializer: params => transformRequestOptions(params)
          }
        )
        .then(response => {
          store.commit('app/LOADING', false)
          resolve(response)
        })
        .catch(error => {
          store.commit('app/LOADING', false)
          reject(error)
        })
    })
  },
  
  addSWOF(ctx, data) {
    store.commit('app/LOADING', true)
    return new Promise((resolve, reject) => {
      axios
        .post(`/studios/swofs/`, data
        )
        .then(response => {
          store.commit('app/LOADING', false)
          resolve(response)
        })
        .catch(error => {
          store.commit('app/LOADING', false)
          reject(error)
        })
    })
  },
  
  updateSWOF(ctx, data) {
    store.commit('app/LOADING', true)
    return new Promise((resolve, reject) => {
      axios
        .patch(`/studios/swofs/${data.id}/`, data
        )
        .then(response => {
          store.commit('app/LOADING', false)
          resolve(response)
        })
        .catch(error => {
          store.commit('app/LOADING', false)
          reject(error)
        })
    })
  },
  
  updateSWOFURL(ctx, data) {
    store.commit('app/LOADING', true)
    return new Promise((resolve, reject) => {
      axios
        .patch(`/studios/swofs/${data.id}/sharepoint/`, data
        )
        .then(response => {
          store.commit('app/LOADING', false)
          resolve(response)
        })
        .catch(error => {
          store.commit('app/LOADING', false)
          reject(error)
        })
    })
  },
  
  addSWOFImage(ctx, data) {
    store.commit('app/LOADING', true)
    return new Promise((resolve, reject) => {
      axios
        .post(`/studios/swofs/${data.swof}/images/`, data
        )
        .then(response => {
          store.commit('app/LOADING', false)
          resolve(response)
        })
        .catch(error => {
          store.commit('app/LOADING', false)
          reject(error)
        })
    })
  },
  updateSWOFImage(ctx, data) {
    store.commit('app/LOADING', true)
    return new Promise((resolve, reject) => {
      axios
        .patch(`/studios/swofs/${data.swof}/images/${data.id}/`, data
        )
        .then(response => {
          store.commit('app/LOADING', false)
          resolve(response)
        })
        .catch(error => {
          store.commit('app/LOADING', false)
          reject(error)
        })
    })
  },
  deleteSWOFImage(ctx, data) {
    store.commit('app/LOADING', true)
    return new Promise((resolve, reject) => {
      axios
        .delete(`/studios/swofs/${data.swof}/images/${data.id}/`)
        .then(response => {
          store.commit('app/LOADING', false)
          resolve(response)
        })
        .catch(error => {
          store.commit('app/LOADING', false)
          reject(error)
        })
    })
  },

  addFavoriteProject(ctx, data) {
    store.commit('app/LOADING', true)
    return new Promise((resolve, reject) => {
      axios
        .post(`/jobs/favorite/`, data)
        .then(response => {
          store.commit('app/LOADING', false)
          resolve(response)
        })
        .catch(error => {
          store.commit('app/LOADING', false)
          reject(error)
        })
    })
  },
  
  deleteFavoriteProject(ctx, data) {
    store.commit('app/LOADING', true)
    return new Promise((resolve, reject) => {
      axios
        .delete(`/jobs/favorite/${data.project}/`,)
        .then(response => {
          store.commit('app/LOADING', false)
          resolve(response)
        })
        .catch(error => {
          store.commit('app/LOADING', false)
          reject(error)
        })
    })
  },

  sendNotificationProject(ctx, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/jobs/projects/${data.job_number}/field_countries/${data.country_code}/notifications/`, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  downloadSWOF(ctx, id ) {
    store.commit('app/LOADING', true)
    
    return new Promise((resolve, reject) => {
        axios
        .patch(`/studios/swofs/${id}/xlsx/`, {}, { responseType:'blob'})
        .then(response => {
            store.commit('app/LOADING', false)
            resolve(response)
        })
        .catch(error => {
            
            store.commit('app/LOADING', false)
            reject(error)
        })
    })
  },
  
  deleteSWOF(ctx, id ) {
    store.commit('app/LOADING', true)
    
    return new Promise((resolve, reject) => {
        axios
        .delete(`/studios/swofs/${id}/`)
        .then(response => {
            store.commit('app/LOADING', false)
            resolve(response)
        })
        .catch(error => {
            
            store.commit('app/LOADING', false)
            reject(error)
        })
    })
  },


  /** One database connection **/
  fetchPackDescProjects(ctx, id) {
      // store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
          axios
          .get(`/odb/projects/${id}/pack_descriptor/`,)
          .then(response => {
              // store.commit('app/LOADING', false)
              resolve(response)
          })
          .catch(error => { 
              // store.commit('app/LOADING', false)
              reject(error) 
          })
      })
  },

  updateODBProject(ctx, { jobNumber, payload }) {
    return new Promise((resolve, reject) => {
      axios.patch(`/odb/projects/${jobNumber}/bulk_update/`, payload)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  // NEW: Add a phase (hits the Viewset action)
  addODBPhase(ctx, { jobNumber, payload }) {
    // payload should be { country_id: 5, cell_name: "Test 2", design_type: "Test" }
    return new Promise((resolve, reject) => {
      axios.post(`/odb/projects/${jobNumber}/phases/`, payload)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  deleteODBPhase(ctx, { jobNumber, cellId }) {
    const payload = { study_id: studyId, phase_id: cellId }
    return new Promise((resolve, reject) => {
      axios.post(`/odb/projects/${jobNumber}/phases/`, payload)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },
  
  fetchODBDataCollections(ctx, queryParams) {
      // store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
          axios
          .get(`/odb/data_collections/`,{
            params: queryParams,
            paramsSerializer: params => transformRequestOptions(params) 
          })
          .then(response => {
              // store.commit('app/LOADING', false)
              resolve(response)
          })
          .catch(error => { 
              // store.commit('app/LOADING', false)
              reject(error) 
          })
      })
  },

  fetchODBFindabilities(ctx, queryParams) {
      // store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
          axios
          .get(`/odb/findabilities/`,{
            params: queryParams,
            paramsSerializer: params => transformRequestOptions(params) 
          })
          .then(response => {
              // store.commit('app/LOADING', false)
              resolve(response)
          })
          .catch(error => { 
              // store.commit('app/LOADING', false)
              reject(error) 
          })
      })
  },
  fetchODBFlashExposures(ctx, queryParams) {
      // store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
          axios
          .get(`/odb/flash_exposures/`,{
            params: queryParams,
            paramsSerializer: params => transformRequestOptions(params) 
          })
          .then(response => {
              // store.commit('app/LOADING', false)
              resolve(response)
          })
          .catch(error => { 
              // store.commit('app/LOADING', false)
              reject(error) 
          })
      })
  },
  fetchODBCommunications(ctx, queryParams) {
      // store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
          axios
          .get(`/odb/communications/`,{
            params: queryParams,
            paramsSerializer: params => transformRequestOptions(params) 
          })
          .then(response => {
              // store.commit('app/LOADING', false)
              resolve(response)
          })
          .catch(error => { 
              // store.commit('app/LOADING', false)
              reject(error) 
          })
      })
  },
  fetchODBProjectOutcomes(ctx, queryParams) {
      // store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
          axios
          .get(`/odb/project_outcomes/`,{
            params: queryParams,
            paramsSerializer: params => transformRequestOptions(params) 
          })
          .then(response => {
              // store.commit('app/LOADING', false)
              resolve(response)
          })
          .catch(error => { 
              // store.commit('app/LOADING', false)
              reject(error) 
          })
      })
  },
  fetchODBProductPositions(ctx) {
      // store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
          axios
          .get(`/odb/product_positions/`,)
          .then(response => {
              // store.commit('app/LOADING', false)
              resolve(response)
          })
          .catch(error => { 
              // store.commit('app/LOADING', false)
              reject(error) 
          })
      })
  },
  
  addPackDescProject(ctx, payload) {
      // store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
          axios
          .post(`jobs/projects/${payload.project}/field_countries/${payload.id}/create_pack_desc/`,payload)
          .then(response => {
              store.commit('app/LOADING', false)
              resolve(response)
          })
          .catch(error => { 
              store.commit('app/LOADING', false)
              reject(error) 
          })
      })
  },
  fetchDatamap(ctx, queryParams) {
      // store.commit('app/LOADING', true)
      return new Promise((resolve, reject) => {
          axios
          .get('/forsta/datamap/', {
              params: queryParams,
              paramsSerializer: params => transformRequestOptions(params) 
          })
          .then(response => {
              // store.commit('app/LOADING', false)
              resolve(response)
          })
          .catch(error => { 
              // store.commit('app/LOADING', false)
              reject(error) 
          })
      })
  },
  fetchMappings(ctx, queryParams) {
      return axios.get('/odb/data_mappings/', {
          params: queryParams,
          paramsSerializer: params => transformRequestOptions(params) 
      })
  },
  createMapping(ctx, payload) {
      return axios.post('/odb/data_mappings/', payload)
  },
  
  // --- STANDARD REST CHECKER ACTIONS ---
  fetchDatamapMapping(ctx, countryId) {
      // Standard GET request to /datamap-mappings/{countryId}/
      return axios.get(`/odb/data_mappings/${countryId}/`)
  },
  saveDatamapMapping(ctx, payload) {
      // Standard PATCH request to update only mapping_data and is_final
      const { project_country, ...data } = payload
      return axios.patch(`/odb/data_mappings/${project_country}/`, data)
  }


  
    // fetchIntercoWorkTypes(ctx, queryParams) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .get('/vision/work_types/', {
    //           params: queryParams,
    //           paramsSerializer: params => transformRequestOptions(params),
    //           
    //         })
    //       .then(response => resolve(response))
    //       .catch(error => reject(error))
    //   })
    // },
    // fetchIntercos(ctx, queryParams) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .get('/vision/intercompanies/', {
    //           params: queryParams,
    //           paramsSerializer: params => transformRequestOptions(params),
    //           
    //         })
    //       .then(response => resolve(response))
    //       .catch(error => reject(error))
    //   })
    // },
    // addInterco(ctx, data) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .post('/vision/intercompanies/', data)
    //       .then(response => resolve(response))
    //       .catch(error => reject(error))
    //   })
    // },
    // updateInterco(ctx, data) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .patch(`/vision/intercompanies/${data.id}/`, {
    //           ...data
    //         })
    //       .then(response => resolve(response))
    //       .catch(error => reject(error))
    //   })
    // },
    // deleteInterco(ctx, data) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .delete(`/vision/intercompanies/${data.id}/`)
    //       .then(response => resolve(response))
    //       .catch(error => reject(error))
    //   })
    // },
  },
  
}
